import React, { useEffect } from 'react'
import { createPortal } from "react-dom";

const InfoPopUp = ({ OkClick, description }) => {
  const OnOkClick = () => {
    OkClick()
  }

  const closeModal = () => {
    OkClick();
  };

  // Disable background page scrolling while this modal is open, and
  // restore whatever the previous value was when it closes/unmounts.
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  // Rendered via a portal directly into document.body so this modal is
  // never trapped behind a sticky page header/nav by an ancestor's
  // stacking context, regardless of where in the component tree it's used.
  return createPortal(
    <>
      <section className="delete-modal">
        <div
          className="modal"
          id="infoModal"
          tabIndex={-1}
          aria-labelledby="ModalFormLabel"
          aria-hidden="true"
          style={{
            display: "block",
            paddingRight: "17px",
            backgroundColor: "#00000094",
            zIndex: 10000,
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            style={{ maxWidth: "850px", width: "100%" }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  onClick={closeModal}
                  style={{
                    backgroundColor: "white",
                    border: "none",
                    color: "red",
                    fontSize: "2rem",
                    fontWeight: "bold",
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "absolute",
                    top: "1px",
                    right: "10px",
                    cursor: "pointer",
                  }}
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div className="container">
                  <div className="delete-modal-main">
                    <div className="text-input-main">
                      <div
                        className="modal-body"
                        dangerouslySetInnerHTML={{ __html: description }}
                      />
                      <div className="confirm-btn-div">
                        <button className="modal-close-btn" onClick={OnOkClick}>
                          Ok
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>,
    document.body,
  );
};

export default InfoPopUp;
